// extracted by mini-css-extract-plugin
module.exports = {"container":"MR4TQ","header":"_3a4ec","text":"_30s4v","textContainer":"_1WpnJ"};